// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router'
// Legacy Vue 2 plugin removed - incompatible with Vue 3
// import CdVueBulma from '../static/js/cd-vue-bulma'

// Minimal Vue 3 compatible stub components
const SimpleStubPlugin = {
  install(app) {
    // Basic component stub factory
    const createStub = (name, tag = 'div', baseClass = '') => {
      app.component(name, {
        name,
        props: {
          color: String,
          fullwidth: Boolean,
          loading: Boolean,
          disabled: Boolean,
          multiple: Boolean,
          accept: String,
          label: String,
          modelValue: [Array, Object, File]
        },
        emits: ['update:modelValue'],
        setup(props, { slots, emit }) {
          if (name === 'cd-file-input') {
            const onChange = (e) => {
              const files = e.target.files
              if (files) {
                const result = props.multiple ? Array.from(files) : files[0]
                emit('update:modelValue', result)
              }
            }
            return () => h('div', { class: 'file' }, [
              h('label', { class: 'file-label' }, [
                h('input', {
                  class: 'file-input',
                  type: 'file',
                  multiple: props.multiple,
                  accept: props.accept,
                  onChange
                }),
                h('span', { class: 'file-cta' }, props.label || 'Choose file(s)')
              ])
            ])
          }
          
          // Standard component stub
          return () => h(tag, {
            class: [
              baseClass,
              props.color && `is-${props.color}`,
              props.fullwidth && 'is-fullwidth',
              props.loading && 'is-loading'
            ].filter(Boolean),
            disabled: props.disabled
          }, slots.default ? slots.default() : [])
        }
      })
    }
    
    // Register required components
    createStub('cd-navbar', 'nav', 'navbar')
    createStub('cd-section', 'section', 'section')
    createStub('cd-field', 'div', 'field')
    createStub('cd-button', 'button', 'button')
    createStub('cd-file-input')
  }
}

// Create application instance
const app = createApp(App)

// Register stub components instead of legacy Vue 2 plugin
app.use(SimpleStubPlugin)
app.use(router)

// Mount
app.mount('#app')
